export function translate<L extends keyof T[K], K extends keyof T, T>(
  translations: T,
  key: K,
  language: L
) {
  return translations[key][language];
}
